import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'scroll-to': 'scroll', } };


        this.movable = this.el.children[0];

        this.el.addEventListener("mousemove", (e) => {
            const position = this.el.getBoundingClientRect();
            const x = e.pageX - position.left - position.width / 2;
            const y = e.pageY - position.top - position.height / 2;
            this.movable.style.transform = "translate(" + x * 0.3 + "px, " + y * 0.5 + "px)";
        });

        this.el.addEventListener("mouseout", (e) => {
            this.movable.style.transform = "translate(0px, 0px)";
        });

    }
    init() {}
    destroy(){}
}



